<div
  class="info-item-wrap"
  [ngClass]="{ tablet: globalUtilsService.isTablet() }"
>
  <a [attr.href]="link ? link : undefined" target="_blank">
    <app-localization-icon
      class="icon"
      *ngIf="icon === 'localization'"
    ></app-localization-icon>
    <app-phone-icon
      class="icon2"
      *ngIf="icon === 'phone'"
    ></app-phone-icon>
    <app-instagram-icon
      class="icon2"
      *ngIf="icon === 'instagram'"
    ></app-instagram-icon>
    <span>{{ label }}</span>
  </a>
</div>
